import { Colors } from '@utils/Colors'

export interface LoadingStep {
  size: string
  bgColor: string
}

const enumLoading: Record<string, LoadingStep> = {
  initial: { size: '25%', bgColor: Colors.PRIMARY100 },
  secondStep: { size: '50%', bgColor: Colors.PRIMARY200 },
  thirdStep: { size: '75%', bgColor: Colors.PRIMARY300 },
  fourthStep: { size: '100%', bgColor: Colors.PRIMARY300 },
  finalizing: { size: '100%', bgColor: Colors.PRIMARY400 },
}

const loadingSteps = [
  { step: enumLoading.initial, delay: 2500 },
  { step: enumLoading.secondStep, delay: 4000 },
  { step: enumLoading.thirdStep, delay: 6000 },
  { step: enumLoading.fourthStep, delay: 8000 },
  { step: enumLoading.finalizing, delay: 11000 },
]

export { enumLoading, loadingSteps }
